import type { IPainterProps, IPainterState } from './Painter';

export interface IImportImageResponse {
  image: HTMLImageElement | ImageBitmap;
  width: number;
  height: number;
}

export const getInitialState = ({
  height,
  initialColor,
  initialLineCap,
  initialLineJoin,
  initialLineWidth,
  width,
}: IPainterProps): IPainterState => ({
  canvasHeight: height || 300,
  canvasWidth: width || 300,
  color: initialColor || '#000',
  isDrawing: false,
  lineCap: initialLineCap || 'round',
  lineJoin: initialLineJoin || 'round',
  lineWidth: initialLineWidth || 3,
});

export const importImage = (baseImage: string): Promise<IImportImageResponse> =>
  new Promise(resolve => {
    const image = new Image();

    image.onload = () => {
      resolve({ image, width: image.naturalWidth, height: image.naturalHeight });
    };

    image.src = baseImage;
  });
